import config from "../config";

// AI Digital Twin --> Icons
import aiDrivenIcon from "../images/icons/ai_driven_icn.png";
import personalisedIcon from "../images/icons/personalised_icn.png";
import medIcon from "../images/icons/med_icn.png";
import coachingIcon from "../images/icons/coaching_icn.png";

// How Twin Work --> Desktop images
import digitalTwinDesktop from "../images/home/digital_twin_card_desktop.png";
import clinicCardDesktop from "../images/home/clinic_card_desktop.png";
import healthCardDesktop from "../images/home/health_card_desktop.png";
import metabolicCardDesktop from "../images/home/metabolic_card_desktop.png";

// How Twin Work --> Mobile images
import digitalTwinMobile from "../images/home/digital_twin_card_mobile.png";
import clinicCardMobile from "../images/home/clinic_card_mobile.png";
import healthCardMobile from "../images/home/health_card_mobile.png";
import metabolicCardMobile from "../images/home/metabolic_card_mobile.png";

// Success Stories --> Video thumbnails
import raviStory from "../images/home/customer-stories/ravi_story.png";
import somasundaramStory from "../images/home/customer-stories/somasundaram_story.png";
import sushilaStory from "../images/home/customer-stories/sushila_story.png";
import anjanaStory from "../images/home/customer-stories/anjana_story.png";
import srinivasaStory from "../images/home/customer-stories/srinivasa_story.png";

// How Twin Work --> Icons
import icon01 from "../images/icons/01.png";
import icon02 from "../images/icons/02.png";
import icon03 from "../images/icons/03.png";
import icon04 from "../images/icons/04.png";

// About Program Page --> Icons
import bloodSugarIcon from "../images/icons/blood_sugar_icn.png";
import healthyWeightIcon from "../images/icons/healthy_weight_icn.png";
import medicationIcon from "../images/icons/medication_icn.png";
import mentalHealthIcon from "../images/icons/mental_health_icn.png";
import bloodPressureIcon from "../images/icons/blood_pressure_icn.png";

const STATES = [
  { key: "Ahmedabad", value: "Ahmedabad" },
  { key: "Bengaluru", value: "Bengaluru" },
  { key: "Chennai", value: "Chennai" },
  { key: "Coimbatore", value: "Coimbatore" },
  { key: "Hyderabad", value: "Hyderabad" },
  { key: "Mumbai", value: "Mumbai" },
  { key: "NCR", value: "NCR" },
  { key: "Pune", value: "Pune" },
  { key: "Trichy", value: "Trichy" },
  { key: "Kochi", value: "Kochi" },
  { key: "Jaipur", value: "Jaipur" },
  { key: "Kolkata", value: "Kolkata" },
];

const REVIEWS = [
  {
    header: "Never thought that diabetes reversal was possible for me",
    subheader: `I was a diabetic for more than 5 years. Now, my sugar level is under control even without medicines. I got back my stamina to run a 21 km half marathon.`,
    rating: 5,
    showBloodLevel: true,
    bloodLevel: {
      text: "Blood Sugar",
      lowLevel: "124",
      highLevel: "233",
    },
    facebookVerified: true,
    userAvator: "NewDesignTwinhealth/Neil_s_result_j0znnq.png",
    userName: "Neil",
    userDetails: "45 Years, Delhi",
  },
  {
    header: "I thought that I was going to be under medication forever",
    subheader: `Twin changed the way I looked at diabetes. I, now, know that a diabetic can be diabetes-free. I can’t believe that I got off medicines within 10 days.`,
    rating: 5,
    showBloodLevel: true,
    bloodLevel: {
      text: "HbA1C dropped",
      lowLevel: "5.7",
      highLevel: "7.1",
    },
    facebookVerified: true,
    userAvator: "Webinar/DS_01109_fjzcje.jpg",
    userName: "Arnav",
    userDetails: "38 Years, Pune",
  },
  {
    header: "The Webinar was the first step towards diabetes reversal",
    subheader: `The doctor busted all kinds of diabetes related myths I had. Q&A session with the doctor & 1:1 consultation with the diabetes expert were turning points of my reversal.`,
    rating: 5,
    showBloodLevel: false,
    bloodLevel: {
      text: "Blood Sugar",
      lowLevel: "124 mg/dl",
      highLevel: "233 mg/dl",
    },
    facebookVerified: true,
    userAvator: "NewDesignTwinhealth/Shourin_big_m8bbmn.jpg",
    userName: "Shaurin",
    userDetails: "48 Years, Mumbai",
  },
  {
    header: "Every Diabetic should attend this webinar",
    subheader: `I have got a 360 degree understanding of the causes of diabetes, its impact on overall health, & the best possible ways to reverse diabetes. It was an eye-opener.`,
    rating: 5,
    showBloodLevel: false,
    bloodLevel: {
      text: "Blood Sugar",
      lowLevel: "124 mg/dl",
      highLevel: "233 mg/dl",
    },
    facebookVerified: true,
    userAvator: "NewDesignTwinhealth/Sunita_big_dlywfe.jpg",
    userName: "Sunita",
    userDetails: "56 Years, Bangalore",
  },
];

const GENDER = [
  { key: "MALE", value: "Male" },
  { key: "FEMALE", value: "Female" },
];

const PAYMENT_PLANS = [
  {
    key: "TWINQP_19750",
    value: "Pay Quarterly: ₹19,750 x 4 instalments (34% Off)",
  },
  {
    key: "TWINAP_69500",
    value: "Pay Upfront: ₹69,500 x 1 instalment (42% Off)",
  },
];

const BOOK_PACK = {
  quarterlylPlan: {
    offerPrice: 30000,
    planPrice: 22500,
    planCode: "GoldPro_Quarter_22500",
    planDay: "Quarterly",
    m2Type: "DIRECT_M2_QUARTERLY",
  },
  annualPlan: {
    offerPrice: 120000,
    planPrice: 72500,
    planCode: "GoldPro_Annual_72500",
    planDay: "Annual",
    m2Type: "DIRECT_M2_ANNUAL",
  },
  coupons: {
    quarterlylPlan: [
      {
        coupon: "TWINQP",
        code: "TWINQP_18750",
        price: 18750,
      },
      {
        coupon: "REVERSEQP",
        code: "TWINQP_19750",
        price: 19750,
      },
    ],
    annualPlan: [
      {
        coupon: "TWINAP",
        code: "TWINAP_64500",
        price: 64500,
      },
      {
        coupon: "REVERSEAP",
        code: "TAP_RIF",
        price: 67500,
      },
      // {
      // 	coupon: "TWINSPECIAL60",
      // 	code: "TWIN_AP_59990",
      // 	price: 59990,
      // },
    ],
  },
};

let TWIN_STORE = {
  plan1: {
    cgmOrderServicePurchased: "TWO_WEEKS",
    planCode: "cgmTestPlan",
    offerPrice: "2,990",
    totalPrice: "",
    offer: "",
  },
  plan2: {
    cgmOrderServicePurchased: "FOUR_WEEKS",
    planCode: "cgmTestPlan",
    offerPrice: "5,490",
    totalPrice: "5,980",
    offer: "8%",
  },
  plan3: {
    cgmOrderServicePurchased: "EIGHT_WEEKS",
    planCode: "cgmTestPlan",
    offerPrice: "10,990",
    totalPrice: "11,960",
    offer: "8%",
  },
};

if (config.APP_ENV === "production") {
  TWIN_STORE = {
    plan1: {
      cgmOrderServicePurchased: "TWO_WEEKS",
      planCode: "TSA_Services_2Week",
      offerPrice: "2,990",
      totalPrice: "",
      offer: "",
    },
    plan2: {
      cgmOrderServicePurchased: "FOUR_WEEKS",
      planCode: "TSA_Service_4week",
      offerPrice: "5,490",
      totalPrice: "5,980",
      offer: "8%",
    },
    plan3: {
      cgmOrderServicePurchased: "EIGHT_WEEKS",
      planCode: "TSA_Service_8week",
      offerPrice: "10,990",
      totalPrice: "11,960",
      offer: "8%",
    },
  };
}

const HOME_PAGE = {
  contact: {
    email: "care@twinhealth.com",
    phone: "9005008946",
  },
  socialLinks: {
    facebook: "https://www.facebook.com/twinhealthindia?mibextid=ZbWKwL",
    linkedin: "https://www.linkedin.com/company/twinforhealth",
    instagram: "https://www.instagram.com/twinhealthindia/",
    youtube: "https://www.youtube.com/channel/UCIerFf2GW7nuLlcDtbgNiGA",
  },
};

const BOOKPACK_LANGUAGES = [
  {
    name: "en",
    display: "English",
  },
  {
    name: "bn",
    display: "Bengali",
  },
  {
    name: "gu",
    display: "Gujarati",
  },
  {
    name: "hi",
    display: "Hindi",
  },
  {
    name: "kn",
    display: "Kannada",
  },
  {
    name: "ml",
    display: "Malayalam",
  },
  {
    name: "mr",
    display: "Marathi",
  },
  {
    name: "ta",
    display: "Tamil",
  },
  {
    name: "te",
    display: "Telugu",
  },
  {
    name: "pa",
    display: "Punjabi",
  },
];

const BOOKPACK_ERROR_MESSAGES = {
  serverError:
    "There seems to be an issue at our end. Please call +91 9005008946 to complete the payment",
};

const BOOKPACK_PINCODE_MESSAGES = {
  serviceable: {
    msg1: "Your location is serviceable!",
    msg2: "We are serving many members in your location already. Welcome to the club!",
  },
  remote: {
    msg1: "Remote operations are available.",
    msg2: "Your location is not serviceable in person. A one-time payment of ₹10,000 is added to cover the cost of the sensor reader.",
  },
  notServiceable: {
    msg1: "Sorry! We are not operational in your location yet.",
    msg2: "Please share your details below to learn about our launch in your location in the near future.",
  },
  default: {
    msg: "  Please share your nearest pincode to whether twin is serviceable in your location",
  },
};

const BOOKPACK_CATEGORIES = {
  TIER_I: "TIER_I",
  TIER_II: "TIER_II",
  TIER_III: "TIER_III",
};

const DOCTOR_REFERRAL = {
  contact: {
    email: "drcare@twinhealth.com",
  },
};

const CSV_UPLOAD_VIDEOS = {
  libreWindowsLink:
    "https://player.vimeo.com/video/816460063?h=24a3c05ca9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  libreMacLink:
    "https://player.vimeo.com/video/816422643?h=946f74d6b7&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  libreProWindowsLink:
    "https://player.vimeo.com/video/816422345?h=bd8cd11ba9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
};

const CSV_UPLOAD_DOWNLOAD_LINKS = {
  libreWindowsLink:
    "https://drive.google.com/file/d/1qt2Gp7w4NqT8yON7zOCdKMxYCk39XETb/view",
  libreMacLink: "https://www.libreview.com/",
  libreProWindowsLink:
    "https://drive.google.com/file/d/1YeZ-ZaecrIL26a-hZn-EOu_0KmzxErxe/view",
};

const GET_IN_TOUCH_LANGUAGES = [
  {
    name: "en",
    display: "English",
  },
  {
    name: "bn",
    display: "Bengali",
  },
  {
    name: "gu",
    display: "Gujarati",
  },
  {
    name: "hi",
    display: "Hindi",
  },
  {
    name: "kn",
    display: "Kannada",
  },
  {
    name: "ml",
    display: "Malayalam",
  },
  {
    name: "mr",
    display: "Marathi",
  },
  {
    name: "ta",
    display: "Tamil",
  },
  {
    name: "te",
    display: "Telugu",
  },
  {
    name: "pa",
    display: "Punjabi",
  },
];

const GET_IN_TOUCH_TIMES = [
  {
    name: "10am-1pm",
    display: "10AM - 1PM",
  },
  {
    name: "1pm-5pm",
    display: "1AM - 5PM",
  },
  {
    name: "5pm-8pm",
    display: "5AM - 8PM",
  },
];

const HOME_PAGE_V2 = {
  topBannerVideoLink:
    "https://player.vimeo.com/progressive_redirect/playback/966395849/rendition/720p/file.mp4?loc=external&log_user=0&signature=9a0f15df5fe38bba0abd859df4ae267320aa82f22ee51f36939046c639ad3bcf",
  adaLink:
    "https://diabetes.org/newsroom/press-releases/2022/artificial-intelligence-offers-significant-rate-remission-type-2-diabetes-compared-to-standard-care",
  floatingLeftCtaText: "Get in touch",
  floatingLeftCtaLink: "/#getInTouch",
  floatingRightCtaText: "Enroll Now",
  floatingRightCtaLink: "/wbdt-care-plan/",
  twinCanHelpVideoLink:
    "https://player.vimeo.com/progressive_redirect/playback/969488118/rendition/1080p/file.mp4?loc=external&log_user=0&signature=578b7c244f7d2343efcd1e341c7c840a92729251a8b41778381a7bcd41caa2d7",
  whatIsTwinVideoLink: "https://www.youtube.com/embed/wlnv1ooaxCg",
};

const METABOLIC_ASSESSMENT_QUESTIONS = [
  {
    id: 1,
    question: "What is your height (Ft) ?",
    options: [],
    type: "dropdown",
  },
  {
    id: 2,
    question: "What is your weight (Kg) ?",
    options: [],
    type: "inputtext",
  },
  {
    id: 3,
    question: "What is your current blood sugar levels (HBA1C) ?",
    options: [
      {
        option: "Less than 7",
        score: "22",
        id: 1,
      },
      {
        option: "7 - 7.9",
        score: "18",
        id: 2,
      },
      {
        option: "8 - 8.9",
        score: "13",
        id: 3,
      },
      {
        option: "9 - 9.9",
        score: "9",
        id: 4,
      },
      {
        option: "10 or more than 10",
        score: "4",
        id: 5,
      },
    ],
    type: "optionselect",
  },
  {
    id: 4,
    question:
      "How many medications are you taking currently to manage your Diabetes?",
    options: [
      {
        option: "No medications",
        score: "37",
        id: 1,
      },
      {
        option: "1 Tablet",
        score: "30",
        id: 2,
      },
      {
        option: "2 Tablets",
        score: "22",
        id: 3,
      },
      {
        option: "3 Tablets or Injectables",
        score: "15",
        id: 4,
      },
      {
        option: "Insulin",
        score: "7",
        id: 5,
      },
    ],
    type: "optionselect",
  },
  {
    id: 5,
    question: "What is your health care expense for the month?",
    options: [
      {
        option: "Under ₹1500",
        score: "0",
        id: 1,
      },
      {
        option: "₹1501 - ₹4000",
        score: "0",
        id: 2,
      },
      {
        option: "₹4001 - ₹6500",
        score: "0",
        id: 3,
      },
      {
        option: "Over ₹6500",
        score: "0",
        id: 4,
      },
      {
        option: "I do not take any medications",
        score: "0",
        id: 5,
      },
    ],
    type: "optionselect",
  },
  {
    id: 6,
    question: "How often you smoke ?",
    options: [
      {
        option: "I don't smoke",
        score: "15",
        id: 1,
      },
      {
        option: "Stopped smoking 10 years back",
        score: "12",
        id: 2,
      },
      {
        option: "Stopped smoking 5 years back",
        score: "9",
        id: 3,
      },
      {
        option: "Stopped smoking 1 year back",
        score: "6",
        id: 4,
      },
      {
        option: "Actively smoke everyday",
        score: "3",
        id: 5,
      },
    ],
    type: "optionselect",
  },
  {
    id: 7,
    question: "How often you consume alcohol ?",
    options: [
      {
        option: "I don't drink",
        score: "15",
        id: 1,
      },
      {
        option: "Once in a month",
        score: "12",
        id: 2,
      },
      {
        option: "1 - 2 times every week",
        score: "9",
        id: 3,
      },
      {
        option: "3 - 6 times every week",
        score: "6",
        id: 4,
      },
      {
        option: "Daily",
        score: "3",
        id: 5,
      },
    ],
    type: "optionselect",
  },
];
const QUIZ_HEIGHT = [
  {
    name: "121.92",
    display: "4'0''",
  },
  {
    name: "124.46",
    display: "4'1''",
  },
  {
    name: "127",
    display: "4'2''",
  },
  {
    name: "129.54",
    display: "4'3''",
  },
  {
    name: "132.08",
    display: "4'4''",
  },
  {
    name: "134.62",
    display: "4'5''",
  },
  {
    name: "137.16",
    display: "4'6''",
  },
  {
    name: "139.70",
    display: "4'7''",
  },
  {
    name: "142.24",
    display: "4'8''",
  },
  {
    name: "144.78",
    display: "4'9''",
  },
  {
    name: "147.32",
    display: "4'10''",
  },
  {
    name: "149.86",
    display: "4'11''",
  },
  {
    name: "152.40",
    display: "5'0''",
  },
  {
    name: "154.94",
    display: "5'1''",
  },
  {
    name: "157.48",
    display: "5'2''",
  },
  {
    name: "160.02",
    display: "5'3''",
  },
  {
    name: "162.56",
    display: "5'4''",
  },
  {
    name: "165.10",
    display: "5'5''",
  },
  {
    name: "167.64",
    display: "5'6''",
  },
  {
    name: "170.18",
    display: "5'7''",
  },
  {
    name: "172.72",
    display: "5'8''",
  },
  {
    name: "175.26",
    display: "5'9''",
  },
  {
    name: "177.80",
    display: "5'10''",
  },
  {
    name: "180.34",
    display: "5'11''",
  },
  {
    name: "182.88",
    display: "6'0''",
  },
  {
    name: "185.42",
    display: "6'1''",
  },
  {
    name: "187.96",
    display: "6'2''",
  },
  {
    name: "190.50",
    display: "6'3''",
  },
  {
    name: "193.04",
    display: "6'4''",
  },
  {
    name: "195.58",
    display: "6'5''",
  },
];
const METABOLIC_ASSESSMENT_RESULTPAGE_PARA = {
  heading1: "Congratulations on taking good care of your health.",
  heading2: "Time to get serious about your health, before it gets worse",
  heading3: "Time to get serious about your health.",
  subHeading1:
    "Your score is below 70, it suggests a deterioration in your diabetes condition and indicates that you may have already experienced or are highly susceptible to developing complications such as impaired eyesight or kidney problems.",
  subHeading2:
    "You're nearing the threshold where additional diabetes-related complications may arise.",
  subHeading3:
    "Your metabolism is currently in a favourable state. Maintain your dedication to good health by enrolling in our metabolic wellness program.",
  para1:
    "At Twin Health, we can help you in achieving Diabetes Reversal, and live a life without the burdens of diabetes.",
  para2:
    "Curious about how we can help? Click on 'Book FREE Consultation' below to schedule a free consultation and discover the ways we can support you.",
};

const QUIZ_LANGUAGES = [
  {
    name: "en",
    display: "English",
  },
  {
    name: "hi",
    display: "Hindi",
  },
  {
    name: "kn",
    display: "Kannada",
  },
  {
    name: "te",
    display: "Telugu",
  },
  {
    name: "ta",
    display: "Tamil",
  },
  {
    name: "ml",
    display: "Malayalam",
  },
];

const DOCTOR_SPECIALISATION = [
  {
    name: "pilot_diabetes",
    display: "Diabetes",
  },
  {
    name: "pilot_obesity",
    display: "Obesity",
  },
  {
    name: "pilot_pre_diabetes",
    display: "Pre-Diabetes",
  },
  {
    name: "pilot_metabolic_wellness",
    display: "Metabollic-Wellness",
  },
  {
    name: "pilot_hypertension",
    display: "Hyper-Tension",
  },
  {
    name: "pilot_pcod",
    display: "PCOD",
  },
];

const METABOLIC_ASSESSMENT_THANKYOUPAGE_VIDEO = {
  video1: "https://www.youtube.com/embed/sp0Y18LvUaE?autoplay=1&mute=1",
  video2: "https://www.youtube.com/embed/cR3gI9lQ06s?autoplay=1&mute=1",
  video3: "https://www.youtube.com/embed/8gVI0SGlXPI?autoplay=1&mute=1",
  video4: "https://www.youtube.com/embed/yDAU4xr2G2A?autoplay=1&mute=1",
  video5: "https://www.youtube.com/embed/Jw9vHIH92Hs?autoplay=1&mute=1",
};

const WBDT_TREATMENT_PLANS = [
  {
    treatmentType: "Diabetes",
    treatmentTypeValue: "wbdt_diabetes",
    plans: [
      {
        planType: "annual_plan",
        text: "Pay annually",
        offerPrice: 83333,
        planPrice: 75000,
        includedItems: [
          "CGM Patch 1 at start of the program",
          "Body Composition Monitor",
          "Blood test at start of the program",
        ],
        excludedItems: [
          "CGM Patch 2,3 at start of program",
          "Blood test on day 90, 180, 270, 360",
          "CGM Patch 4,5,6 on day 90, 180, 270 of program",
          "Ketone meter",
          "Smart watch",
        ],
      },
      // {
      //   planType: "installment_plan",
      //   text: "Pay in half yearly installments",
      //   offerPrice: 40000,
      //   planPrice: 39999,
      //   includedItems: [
      //     "Body Composition Monitor",
      //     "Blood test at start of the program",
      //   ],
      //   excludedItems: [
      //     "CGM Patch 1,2,3 at start of program",
      //     "Blood test on day 90, 180, 270, 360",
      //     "CGM Patch 4,5,6 on day 90, 180, 270 of program",
      //     "Ketone meter",
      //     "Smart watch",
      //   ],
      // },
      {
        planType: "quarterly_plan",
        text: "Pay in quarterly installments",
        offerPrice: 25000,
        planPrice: 22499,
        includedItems: ["Blood test at start of the program"],
        excludedItems: [
          "Body Composition Monitor",
          "CGM Patch 1,2,3 at start of program",
          "Blood test on day 90, 180, 270, 360",
          "CGM Patch 4,5,6 on day 90, 180, 270 of program",
          "Ketone meter",
          "Smart watch",
        ],
      },
    ],
  },
  {
    treatmentType: "Obesity",
    treatmentTypeValue: "wbdt_obesity",
    plans: [
      {
        planType: "annual_plan",
        text: "Pay annually",
        offerPrice: 83333,
        planPrice: 75000,
        includedItems: [
          "CGM Patch 1 at start of the program",
          "Body Composition Monitor",
          "Blood test at start of the program",
        ],
        excludedItems: ["Blood test on day 90, 180, 270, 360", "Smart watch"],
      },
      // {
      //   planType: "installment_plan",
      //   text: "Pay in half yearly installments",
      //   offerPrice: 45000,
      //   planPrice: 39999,
      //   includedItems: [
      //     "Body Composition Monitor",
      //     "Blood test at start of the program",
      //   ],
      //   excludedItems: [
      //     "CGM Patch 1 at start of program",
      //     "Blood test on day 90, 180, 270, 360",
      //     "Smart watch",
      //   ],
      // },
      {
        planType: "quarterly_plan",
        text: "Pay in quarterly installments",
        offerPrice: 25000,
        planPrice: 22499,
        includedItems: ["Blood test at start of the program"],
        excludedItems: [
          "Body Composition Monitor",
          "CGM Patch 1 at start of program",
          "Blood test on day 90, 180, 270, 360",
          "Smart watch",
        ],
      },
    ],
  },
  {
    treatmentType: "Hypertension",
    treatmentTypeValue: "wbdt_hypertension",
    plans: [
      {
        planType: "annual_plan",
        text: "Pay annually",
        offerPrice: 83333,
        planPrice: 75000,
        includedItems: [
          "CGM Patch 1 at start of the program",
          "Body Composition Monitor",
          "Blood test at start of the program",
        ],
        excludedItems: [
          "Blood test on day 90, 180, 270, 360",
          "BP Testing machine",
          "Smart watch",
        ],
      },
      // {
      //   planType: "installment_plan",
      //   text: "Pay in half yearly installments",
      //   offerPrice: 45000,
      //   planPrice: 39999,
      //   includedItems: [
      //     "Body Composition Monitor",
      //     "Blood test at start of the program",
      //   ],
      //   excludedItems: [
      //     "CGM Patch 1 at start of program",
      //     "Blood test on day 90, 180, 270, 360",
      //     "BP Testing machine",
      //     "Smart watch",
      //   ],
      // },
      {
        planType: "quarterly_plan",
        text: "Pay in quarterly installments",
        offerPrice: 25000,
        planPrice: 22499,
        includedItems: ["Blood test at start of the program"],
        excludedItems: [
          "Body Composition Monitor",
          "CGM Patch 1 at start of program",
          "Blood test on day 90, 180, 270, 360",
          "BP Testing machine",
          "Smart watch",
        ],
      },
    ],
  },
  {
    treatmentType: "Dyslipedimia",
    treatmentTypeValue: "wbdt_dyslipedimia",
    plans: [
      {
        planType: "annual_plan",
        text: "Pay annually",
        offerPrice: 83333,
        planPrice: 75000,
        includedItems: [
          "CGM Patch 1 at start of the program",
          "Body Composition Monitor",
          "Blood test at start of the program",
        ],
        excludedItems: ["Blood test on day 90, 180, 270, 360", "Smart watch"],
      },
      // {
      //   planType: "installment_plan",
      //   text: "Pay in half yearly installments",
      //   offerPrice: 45000,
      //   planPrice: 39999,
      //   includedItems: [
      //     "Body Composition Monitor",
      //     "Blood test at start of the program",
      //   ],
      //   excludedItems: [
      //     "CGM Patch 1 at start of program",
      //     "Blood test on day 90, 180, 270, 360",
      //     "Smart watch",
      //   ],
      // },
      {
        planType: "quarterly_plan",
        text: "Pay in quarterly installments",
        offerPrice: 25000,
        planPrice: 22499,
        includedItems: ["Blood test at start of the program"],
        excludedItems: [
          "Body Composition Monitor",
          "CGM Patch 1 at start of program",
          "Blood test on day 90, 180, 270, 360",
          "Smart watch",
        ],
      },
    ],
  },
  {
    treatmentType: "PCOD",
    treatmentTypeValue: "wbdt_pcod",
    plans: [
      {
        planType: "annual_plan",
        text: "Pay annually",
        offerPrice: 83333,
        planPrice: 75000,
        includedItems: [
          "CGM Patch 1 at start of the program",
          "Body Composition Monitor",
          "Blood test at start of the program",
        ],
        excludedItems: ["Blood test on day 90, 180, 270, 360", "Smart watch"],
      },
      // {
      //   planType: "installment_plan",
      //   text: "Pay in half yearly installments",
      //   offerPrice: 45000,
      //   planPrice: 39999,
      //   includedItems: [
      //     "Body Composition Monitor",
      //     "Blood test at start of the program",
      //   ],
      //   excludedItems: [
      //     "CGM Patch 1 at start of program",
      //     "Blood test on day 90, 180, 270, 360",
      //     "Smart watch",
      //   ],
      // },
      {
        planType: "quarterly_plan",
        text: "Pay in quarterly installments",
        offerPrice: 25000,
        planPrice: 22499,
        includedItems: ["Blood test at start of the program"],
        excludedItems: [
          "Body Composition Monitor",
          "CGM Patch 1 at start of program",
          "Blood test on day 90, 180, 270, 360",
          "Smart watch",
        ],
      },
    ],
  },
  {
    treatmentType: "MAFLD",
    treatmentTypeValue: "wbdt_mafld",
    plans: [
      {
        planType: "annual_plan",
        text: "Pay annually",
        offerPrice: 83333,
        planPrice: 75000,
        includedItems: [
          "CGM Patch 1 at start of the program",
          "Body Composition Monitor",
          "Blood test at start of the program",
        ],
        excludedItems: ["Blood test on day 90, 180, 270, 360", "Smart watch"],
      },
      // {
      //   planType: "installment_plan",
      //   text: "Pay in half yearly installments",
      //   offerPrice: 45000,
      //   planPrice: 39999,
      //   includedItems: [
      //     "Body Composition Monitor",
      //     "Blood test at start of the program",
      //   ],
      //   excludedItems: [
      //     "CGM Patch 1 at start of program",
      //     "Blood test on day 90, 180, 270, 360",
      //     "Smart watch",
      //   ],
      // },
      {
        planType: "quarterly_plan",
        text: "Pay in quarterly installments",
        offerPrice: 25000,
        planPrice: 22499,
        includedItems: ["Blood test at start of the program"],
        excludedItems: [
          "Body Composition Monitor",
          "CGM Patch 1 at start of program",
          "Blood test on day 90, 180, 270, 360",
          "Smart watch",
        ],
      },
    ],
  },
  {
    treatmentType: "Psoriasis",
    treatmentTypeValue: "wbdt_psoriasis",
    plans: [
      {
        planType: "annual_plan",
        text: "Pay annually",
        offerPrice: 83333,
        planPrice: 75000,
        includedItems: [
          "CGM Patch 1 at start of the program",
          "Body Composition Monitor",
          "Blood test at start of the program",
        ],
        excludedItems: ["Blood test on day 90, 180, 270, 360", "Smart watch"],
      },
      // {
      //   planType: "installment_plan",
      //   text: "Pay in half yearly installments",
      //   offerPrice: 45000,
      //   planPrice: 39999,
      //   includedItems: [
      //     "Body Composition Monitor",
      //     "Blood test at start of the program",
      //   ],
      //   excludedItems: [
      //     "CGM Patch 1 at start of program",
      //     "Blood test on day 90, 180, 270, 360",
      //     "Smart watch",
      //   ],
      // },
      {
        planType: "quarterly_plan",
        text: "Pay in quarterly installments",
        offerPrice: 25000,
        planPrice: 22499,
        includedItems: ["Blood test at start of the program"],
        excludedItems: [
          "Body Composition Monitor",
          "CGM Patch 1 at start of program",
          "Blood test on day 90, 180, 270, 360",
          "Smart watch",
        ],
      },
    ],
  },
];

// Header Navigation Items
const HEADER_NAV_ITEMS = [
  { label: "About Program", link: "/about-program/" },
  { label: "For Employers", link: "/for-employers/" },
  { label: "For Doctors", link: "/for-doctors/" },
  { label: "For Insurers", link: "/for-insurers/" },
  { label: "Company", link: "/about-us/" },
  { label: "Resources", link: "/resource/" },
  { label: "Careers", link: "/career/" },
];

// Header CTA Buttons
const HEADER_CTA_BUTTONS = {
  contact: {
    label: "Contact US",
    link: "/contact/",
  },
  enroll: {
    label: "Enroll now",
    link: "/wbdt-care-plan/",
  },
};

// Mixpanel Tracking Configuration
const MIXPANEL_HEADER_CONFIG = {
  asset: "Twin Health India Website",
  assetName: "Twin Health India Corporate Website",
  locations: {
    header: "Header",
    mobileMenu: "Mobile Header Menu",
  },
};

// Footer Navigation Items
const FOOTER_NAV_ITEMS = [
  { label: "About Program", link: "/about-program/" },
  { label: "For Employers", link: "/for-employers/" },
  { label: "For Doctors", link: "/for-doctors/" },
  { label: "For Insurers", link: "/for-insurers/" },
  { label: "Company", link: "/about-us/" },
  { label: "Resources", link: "/resource/" },
  { label: "Careers", link: "/career/" },
  { label: "FAQ", link: "/faq/" },
];

// Footer Social Media Links
const FOOTER_SOCIAL_LINKS = [
  {
    name: "LinkedIn",
    url: "https://in.linkedin.com/company/twin-health-india",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/twinhealthindia",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/twinhealthindia/",
  },
  {
    name: "Twitter",
    url: "https://x.com/twinhealthindia",
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@twinhealthindia/videos",
  },
];

// Footer App Store Links
const FOOTER_APP_LINKS = {
  appStore: {
    url: "https://apps.apple.com/in/app/twin-health/id1456423142",
  },
  playStore: {
    url: "https://play.google.com/store/apps/details?id=com.twinsdigital.v2&hl=en_IN",
  },
};

// Footer Contact Information
const FOOTER_CONTACT_INFO = {
  phone: {
    display: "+91 9005008946",
    link: "tel:+919005008946",
  },
  email: {
    display: "care@twinhealth.com",
    link: "mailto:care@twinhealth.com",
  },
};

// Footer Legal Links
const FOOTER_LEGAL_LINKS = [
  { label: "Privacy Policy", link: "/privacy-policy/" },
  { label: "Terms Of use", link: "/terms/" },
];

// Mixpanel Footer Configuration
const MIXPANEL_FOOTER_CONFIG = {
  asset: "Twin Health India Website",
  assetName: "Twin Health India Corporate Website",
  locations: {
    footer: "Footer",
  },
};

// Cards data
const AI_DIGITAL_TWIN_CARDS = [
  {
    icon: aiDrivenIcon,
    title: "AI-Driven Health Insights",
    description: "Real-time guidance based on your body's data",
    iconAlt: "AI-Driven Health Insights Icon",
  },
  {
    icon: personalisedIcon,
    title: "Personalized Plans",
    description: "Aligned with Indian diets & habits",
    iconAlt: "Personalized Plans Icon",
  },
  {
    icon: medIcon,
    title: "Medication-Free Reversal",
    description: "90%+ users reduce or eliminate medications*",
    iconAlt: "Medication-Free Reversal Icon",
  },
  {
    icon: coachingIcon,
    title: "24/7 Coaching & Support",
    description: "Doctors, nutritionists & health experts on demand",
    iconAlt: "24/7 Coaching & Support Icon",
  },
];

// Cards data
const ABOUT_PROGRAM_PAGE_CARDS = [
  {
    icon: bloodSugarIcon,
    title: "Normalise Blood Sugar",
    description: "",
    iconAlt: "Blood Sugar Icon",
  },
  {
    icon: healthyWeightIcon,
    title: "Achieve Healthy Weight",
    description: "",
    iconAlt: "Healthy Weight Icon",
  },
  {
    icon: bloodPressureIcon,
    title: "Regulate Blood Pressure",
    description: "",
    iconAlt: "Blood Pressure Icon",
  },
  {
    icon: medicationIcon,
    title: "Reduce/Eliminate Medication",
    description: "",
    iconAlt: "Medication Icon",
  },
  {
    icon: mentalHealthIcon,
    title: "Improved Mental Health",
    description: "",
    iconAlt: "Mental Health Icon",
  },
];

const HOW_TWIN_WORK_CARDS = [
  {
    id: 1,
    step: "01",
    title: "Build Your Digital Twin",
    description:
      "Twin integrates 3000+ daily data points to create your unique metabolic model.",
    desktopImg: digitalTwinDesktop,
    mobileImg: digitalTwinMobile,
    icon: icon01,
  },
  {
    id: 2,
    step: "02",
    title: "A compassionate clinical care team",
    description:
      "Twin's AI guides with precision, while the care team drives adherence and lasting change.",
    desktopImg: clinicCardDesktop,
    mobileImg: clinicCardMobile,
    icon: icon02,
  },
  {
    id: 3,
    step: "03",
    title: "Real-Time Health Adjustments",
    description:
      "Twin AI refines recommendations daily, adapting to your body's response in real time.",
    desktopImg: healthCardDesktop,
    mobileImg: healthCardMobile,
    icon: icon03,
  },
  {
    id: 4,
    step: "04",
    title: "Achieve Lasting Metabolic Reversal",
    description:
      "9 out of 10 members reduce or eliminate medications while sustaining long-term health.",
    desktopImg: metabolicCardDesktop,
    mobileImg: metabolicCardMobile,
    icon: icon04,
  },
];

const CLINICAL_RESEARCH_CARDS = [
  {
    title: "American Heart Association",
    description:
      "Concordance between the Various Cardiovascular Risk Scores: Six Months Results of the Randomised Clinical Trial Evaluating Whole-Body Digital Twin Technology Enabled Precision Nutrition for Remission of Diabetes. Journal of AHA - Circulation, 2022;146:A14842.",
  },
  {
    title: "American Diabetes Association",
    description:
      "Whole Body Digital Twin (WBDT) Enabled Diabetes Reversal—US Real-World Findings. Diabetes. 2024 Jun 14;73(Supplement_1).",
  },
  {
    title: "JACC Journals",
    description:
      "Digital twin in managing hypertension among people with type 2 diabetes: 1-year randomized controlled trial. JACC: Advances. 2024 Sep 1;3(9_Part_2):101172.",
  },
  {
    title: "Endocrine Society",
    description:
      "Impact Of Digital Twin Intervention On Visceral Fat And Glycemic Control In T2dm With Different Levels Of Visceral Fat. J Endocr Soc. 2023 Oct 5;7(Suppl 1):bvad114.874.",
  },
  {
    title: "Nature",
    description:
      "One-year outcomes of a digital twin intervention for type 2 diabetes: a retrospective real-world study. Nature Scientific Reports. 2024 Oct 26;14(1):25478.",
  },
  {
    title: "Diabetes Technology & Therapeutics",
    description:
      "Correlation of Continuous Glucose Monitoring Metrics with HbA1c reduction And Beta Cell Function at one year of Whole-Body Digital Twin Technology for Remission of Diabetes. Diabetes Technology & Therapeutics, Feb 2023.A-1-A-269.",
  },
  {
    title: "AACE Endocrine Practice™",
    description:
      "Digital Twin Technology in Resolving Polycystic Ovary Syndrome and improving Metabolic Health: A comprehensive case study. Endocrine Practice, 2024 May;30(5):(Suppl)S130.",
  },
  {
    title: "The Lancet",
    description:
      "Digital Twin Intervention for Type 2 Diabetes: One-Year Outcomes of a Randomized Trial, LANCET Pre-print SSRN 4499693.",
  },
];

const SUCCESS_STORIES_VIDEOS = [
  {
    id: 1,
    thumbnail: raviStory,
    videoLink: "https://www.youtube.com/embed/TSzjGfm68U4",
  },
  {
    id: 2,
    thumbnail: somasundaramStory,
    videoLink: "https://www.youtube.com/embed/k3u2dStnteo",
  },
  {
    id: 3,
    thumbnail: sushilaStory,
    videoLink: "https://www.youtube.com/embed/AXLCf3SSkZg",
  },
  {
    id: 4,
    thumbnail: anjanaStory,
    videoLink: "https://www.youtube.com/embed/JOqyUj-lqCU",
  },
  {
    id: 5,
    thumbnail: srinivasaStory,
    videoLink: "https://www.youtube.com/embed/IFPFEvMorM4",
  },
];

// FAQ HomePage
const HOMEPAGE_FAQ = [
  {
    key: "faq-01",
    index: "01",
    title: "Can metabolic conditions like diabetes or PMOS be reversed?",
    desc: "Yes, absolutely. Twin Health helps you reverse these conditions, not just manage them. Unlike generic advice, Twin Precision Treatment uses the Whole Body Digital Twin™ to analyze your unique biology, targeting the root cause—dysfunctional metabolism—to achieve clinical remission.",
    eventName: "FAQ1_clicked",
    eventDesc: "user clicks on FAQ1",
  },
  {
    key: "faq-02",
    index: "02",
    title: "How does Twin Health improve metabolism?",
    desc: "Twin Health tracks how your body reacts to food, sleep and movement. Once it understands your patterns, it guides you with small daily changes that help your metabolism work more smoothly. Over time, this leads to better balance and more steady energy.",
    eventName: "FAQ2_clicked",
    eventDesc: "user clicks on FAQ2",
  },
  {
    key: "faq-03",
    index: "03",
    title: "How long does it take to improve metabolism?",
    desc: "Results appear quickly, but true healing follows a structured, four-phase journey guided by your Whole Body Digital Twin™: 1. Reduce Metabolic health toxicity/inflammation; 2. Remission begins; 3. Deep organ healing; 4. Focus on lasting metabolic health.",
    eventName: "FAQ3_clicked",
    eventDesc: "user clicks on FAQ3",
  },
  {
    key: "faq-04",
    index: "04",
    title: "Will I need to change my medication?",
    desc: "Yes, Our goal is to safely reduce and eventually eliminate your medications, not just manage them. As your metabolic health improves, your Twin Doctor continuously monitors real-time data to safely reduce your dosage, ensuring you never take medicine your body no longer needs.",
    eventName: "FAQ4_clicked",
    eventDesc: "user clicks on FAQ4",
  },
  {
    key: "faq-05",
    index: "05",
    title: "Is Twin Health suitable for Indian food and lifestyle habits?",
    desc: "Absolutely. The program is built around everyday Indian meals and routines. You don’t have to follow extreme diets instead you just learn what works best for your body.",
    eventName: "FAQ5_clicked",
    eventDesc: "user clicks on FAQ5",
  },
  {
    key: "faq-06",
    index: "06",
    title: "What is Twin Health about?",
    desc: "Twin Health's AI Digital Twin™maps your unique metabolic health, healing its root dysfunction. This enables medication elimination, beta cell regeneration, and sustainable remission from chronic metabolic diseases.",
    eventName: "FAQ6_clicked",
    eventDesc: "user clicks on FAQ6",
  },
  {
    key: "faq-07",
    index: "07",
    title: "Can diabetes be reversed?",
    desc: "Twin Health reverses diabetes, validated by IIT Madras (94% reversal in RCTs). The AIl Twin™ targets root cause (dysfunctional metabolism) for clinical remission: 95% stop all meds, 94% stop insulin, and beta cells regenerate. Results start in 2 weeks; full remission in 3 months.",
    eventName: "FAQ7_clicked",
    eventDesc: "user clicks on FAQ7",
  },
  {
    key: "faq-08",
    index: "08",
    title: "How does Twin Health work? ",
    desc: "Twin Health uses its AI Digital Twin™ (AI/sensors) to map your unique metabolism and heal root dysfunction. This precision allows you to safely eliminate medications, regenerate beta cells, and achieve sustainable remission for chronic diseases (Diabetes, PMOS, Obesity, etc.) by reversing them.",
    eventName: "FAQ8_clicked",
    eventDesc: "user clicks on FAQ8",
  },
];

// FAQ About Program Page
const ABOUT_PROGRAM_FAQ = [
  {
    key: "faq-01",
    index: "01",
    title: "Can metabolic diseases like diabetes or PMOS be reversed?",
    desc: "Many metabolic conditions can improve significantly and may even reach remission when lifestyle, nutrition, activity and sleep patterns are optimised. Twin Health supports this improvement through real-time monitoring, personalised guidance and medical supervision.",
    eventName: "FAQ1_clicked",
    eventDesc: "user clicks on FAQ1",
  },
  {
    key: "faq-02",
    index: "02",
    title: "How long does it take to see results with Twin Health?",
    desc: "Most members begin noticing improvements such as better energy, reduced sugar spikes and improved sleep within the first 1–3 months. Deeper metabolic healing usually occurs between 3–12 months.",
    eventName: "FAQ2_clicked",
    eventDesc: "user clicks on FAQ2",
  },
  {
    key: "faq-03",
    index: "03",
    title: "Does Twin Health replace my doctor or medications?",
    desc: "No. Medication changes are made only by your treating doctor. Twin Health provides data-driven insights and lifestyle guidance that your clinical team uses to make informed decisions.",
    eventName: "FAQ3_clicked",
    eventDesc: "user clicks on FAQ3",
  },
  {
    key: "faq-04",
    index: "04",
    title: "What conditions does Twin Health help with?",
    desc: "Twin Health helps people manage lifestyle diseases like type 2 diabetes, obesity, PMOS, fatty liver disease, hypertension and high cholesterol by improving metabolic health through personalised metabolic monitoring and data insights.",
    eventName: "FAQ4_clicked",
    eventDesc: "user clicks on FAQ4",
  },
  {
    key: "faq-05",
    index: "05",
    title: "How does the AI Digital Twin work?",
    desc: "The AI Digital Twin collects data from sensors and smart devices to show how your metabolism responds to food, activity, sleep and stress. This helps you make daily choices that support better metabolic health.",
    eventName: "FAQ5_clicked",
    eventDesc: "user clicks on FAQ5",
  },
  {
    key: "faq-06",
    index: "06",
    title: "Is Twin Health safe for all age groups?",
    desc: "Twin Health is designed for adults with metabolic conditions. A doctor reviews your medical history before recommending a personalised plan.",
    eventName: "FAQ6_clicked",
    eventDesc: "user clicks on FAQ6",
  },
  {
    key: "faq-07",
    index: "07",
    title: "Do I need to wear sensors all the time?",
    desc: "Sensors like CGMs and trackers help you understand your body's responses in real time. Most members wear them during the initial months for accurate metabolic mapping.",
    eventName: "FAQ7_clicked",
    eventDesc: "user clicks on FAQ7",
  },
  {
    key: "faq-08",
    index: "08",
    title: "Can I follow my regular diet with Twin Health?",
    desc: "Your Digital Twin helps you identify which foods suit your metabolism. Instead of fixed meal plans, you receive personalised guidance based on how your body reacts to specific foods",
    eventName: "FAQ8_clicked",
    eventDesc: "user clicks on FAQ8",
  },
];

// FAQ For Employers Page
const FOR_EMPLOYERS_FAQ = [
  {
    key: "faq-01",
    index: "01",
    title:
      "How is Evergreen by Twin Health different from typical corporate care programs?",
    desc: "Most generic health programs stop at awareness. Evergreen improves real employee health using personalised metabolic insights, coaching, and daily guidance that leads to fewer sick days and higher energy.",
    eventName: "FAQ1_clicked",
    eventDesc: "user clicks on FAQ1",
  },
  {
    key: "faq-02",
    index: "02",
    title: "How do you ensure employee privacy and data protection?",
    desc: "Twin Health meets HIPAA, ISO 27001, GDPR and Indian data laws. Employers receive only aggregated workforce insights. Thus, individual data is fully private.",
    eventName: "FAQ2_clicked",
    eventDesc: "user clicks on FAQ2",
  },
  {
    key: "faq-03",
    index: "03",
    title: "What kind of results can we expect for our workforce?",
    desc: "Companies see real improvements within 3–6 months with higher energy levels, fewer sick days, better focus, and lower medical claims.",
    eventName: "FAQ3_clicked",
    eventDesc: "user clicks on FAQ3",
  },
  {
    key: "faq-04",
    index: "04",
    title:
      "How does Evergreen by Twin Health measure success and ROI for employers?",
    desc: "We measure clinical and business outcomes — reduced hospital visits, lower medication use, improved energy scores, fewer claims, and better productivity.",
    eventName: "FAQ4_clicked",
    eventDesc: "user clicks on FAQ4",
  },
  {
    key: "faq-05",
    index: "05",
    title: "What is an employee care program?",
    desc: "An employee care program is a structured plan that helps employees improve their health through lifestyle guidance, preventive care, coaching and better daily habits.",
    eventName: "FAQ5_clicked",
    eventDesc: "user clicks on FAQ5",
  },
  {
    key: "faq-06",
    index: "06",
    title: "What are the 7 components of care?",
    desc: "The 7 components of care include physical, emotional, social, spiritual, intellectual, environmental and occupational wellbeing. These together define a healthy employee.",
    eventName: "FAQ6_clicked",
    eventDesc: "user clicks on FAQ6",
  },
  {
    key: "faq-07",
    index: "07",
    title: "What are ideas for an employee care programme?",
    desc: "Small changes make a big difference for example guided nutrition plans, stress support, walking breaks, sleep coaching, mental health check-ins and metabolic insights are some of the most effective ideas.",
    eventName: "FAQ7_clicked",
    eventDesc: "user clicks on FAQ7",
  },
  {
    key: "faq-08",
    index: "08",
    title: "What are the 5 ways to wellbeing at work?",
    desc: "Five proven ways include: moving more, eating better, building social connection, improving sleep and managing stress. These habits directly improve employee wellbeing.",
    eventName: "FAQ8_clicked",
    eventDesc: "user clicks on FAQ8",
  },
  {
    key: "faq-09",
    index: "09",
    title: "What are the 6 components of care?",
    desc: "The 6 components are physical, emotional, social, spiritual, intellectual and occupational health. A good care program supports all six.",
    eventName: "FAQ9_clicked",
    eventDesc: "user clicks on FAQ9",
  },
  {
    key: "faq-10",
    index: "10",
    title: "How to create an employee care program?",
    desc: "Start by understanding employee needs, then introduce health tracking, coaching, nutrition support, stress management, and clear progress metrics. Technology and personalisation make programs far more effective.",
    eventName: "FAQ10_clicked",
    eventDesc: "user clicks on FAQ10",
  },
];

// FAQ For Doctors Page
const FOR_DOCTORS_PAGE_FAQ = [
  {
    key: "faq-01",
    index: "01",
    title: "What is a healthcare partnership program?",
    desc: "A healthcare partnership program is simply a way for doctors to work closely with a support system that provides technology, monitoring, and patient education. You continue leading the clinical decisions, while the program handles the daily guidance and data that patients usually struggle to follow on their own.",
    eventName: "FAQ1_clicked",
    eventDesc: "user clicks on FAQ1",
  },
  {
    key: "faq-02",
    index: "02",
    title: "How does Twin Health support doctors in India?",
    desc: "Twin Health gives you access to real-time metabolic data, an easy-to-use dashboard, and AI-driven insights that make it easier to track progress. You don’t lose control of treatment, Moreover, the platform just strengthens what you already do in your clinic.",
    eventName: "FAQ2_clicked",
    eventDesc: "user clicks on FAQ2",
  },
  {
    key: "faq-03",
    index: "03",
    title: "Which patients benefit most from Twin Health?",
    desc: "Patients dealing with lifestyle-related conditions like diabetes, obesity, PMOS, hypertension and metabolic syndrome typically see the strongest improvements because the program guides them through daily habits and lifestyle changes that are hard to manage on their own.",
    eventName: "FAQ3_clicked",
    eventDesc: "user clicks on FAQ3",
  },
  {
    key: "faq-04",
    index: "04",
    title: "Does Twin Health replace the doctor?",
    desc: "No. The doctor stays fully in charge. Twin Health provides the day-to-day monitoring, lifestyle support, and data, but every major medical decision is still made by the clinician.",
    eventName: "FAQ4_clicked",
    eventDesc: "user clicks on FAQ4",
  },
  {
    key: "faq-05",
    index: "05",
    title: "How does Twin Health help improve patient outcomes?",
    desc: "The system tracks sleep, stress, activity, nutrition and metabolic patterns to highlight what’s helping and what’s hurting. This gives doctors clearer visibility into what’s driving a patient’s progress, making it easier to personalise treatment and reduce medications safely.",
    eventName: "FAQ5_clicked",
    eventDesc: "user clicks on FAQ5",
  },
  {
    key: "faq-06",
    index: "06",
    title: "How easy is it for clinics to onboard patients?",
    desc: "It’s straightforward. Enrolment can be done in minutes through the partner dashboard, and once the patient is on board, the system handles continuous tracking and reminders. Doctors just review the data during consultations.",
    eventName: "FAQ6_clicked",
    eventDesc: "user clicks on FAQ6",
  },
];

// FAQ For Insurance Page
const FOR_INSURERS_PAGE_FAQ = [
  {
    key: "faq-01",
    index: "01",
    title: "What does an insurance partner do in healthcare?",
    desc: "Insurance partners work with health providers to improve member health, reduce avoidable claims, and shift from reactive care to proactive care. It’s a collaboration that benefits both insurers and policyholders.",
    eventName: "FAQ1_clicked",
    eventDesc: "user clicks on FAQ1",
  },
  {
    key: "faq-02",
    index: "02",
    title: "How can metabolic care programmes help insurers reduce claims?",
    desc: "When members receive early support for conditions like diabetes, BP, or obesity, they stay healthier and avoid hospitalizations. This naturally brings claim amounts down.",
    eventName: "FAQ2_clicked",
    eventDesc: "user clicks on FAQ2",
  },
  {
    key: "faq-03",
    index: "03",
    title: "How does Twin Health support insurance partners?",
    desc: "Twin Health gives insurers real-time health insights, AI-driven early risk detection, and personalised guidance for members. This leads to better outcomes and fewer high-cost claims.",
    eventName: "FAQ3_clicked",
    eventDesc: "user clicks on FAQ3",
  },
  {
    key: "faq-04",
    index: "04",
    title:
      "Can Twin Health’s program integrate into our existing insurance plans?",
    desc: "Yes. The platform can be added as a health benefit or fully integrated into care plans. It works with individual and group insurance products.",
    eventName: "FAQ4_clicked",
    eventDesc: "user clicks on FAQ4",
  },
  {
    key: "faq-05",
    index: "05",
    title: "What results can insurers expect?",
    desc: "Insurers typically see healthier members, fewer hospital stays, lower claims, and stronger retention. Many partners report measurable improvements within months.",
    eventName: "FAQ5_clicked",
    eventDesc: "user clicks on FAQ5",
  },
  {
    key: "faq-06",
    index: "06",
    title: "Is member data secure with Twin Health?",
    desc: "Absolutely. We follow HIPAA, ISO 27001, GDPR, and Indian data protection laws. Data is encrypted and shared only with consent.",
    eventName: "FAQ6_clicked",
    eventDesc: "user clicks on FAQ6",
  },
  {
    key: "faq-07",
    index: "07",
    title: "How does AI help insurers improve outcomes?",
    desc: "AI identifies early signs of metabolic risk and offers personalised daily guidance. This keeps members healthier and reduces the need for claims later.",
    eventName: "FAQ7_clicked",
    eventDesc: "user clicks on FAQ7",
  },
];

// FAQ For Employers Page
const ENROLL_NOW_PAGE_FAQ = [
  {
    key: "faq-01",
    index: "01",
    title: "What’s included in the Twin Health program?",
    desc: "You get the Twin Health India app and a care team of doctors and coaches who guide your journey from day one. Behind the scenes, the Digital Twin™  technology learns how your body responds to food, sleep, activity and stress, so your care team can build a highly precise, personalised plan and adjust it as you go.",
    eventName: "FAQ1_clicked",
    eventDesc: "user clicks on FAQ1",
  },
  {
    key: "faq-02",
    index: "02",
    title: "Is the program suitable for everyone?",
    desc: "It's designed for people managing diabetes, pre-diabetes, obesity, PMOS, hypertension, fatty liver, or general metabolic care. If you fall into one of these categories, you're a good fit. If your situation is more complex or falls outside this list, our team can have a quick conversation with you to confirm the programme is right before you sign up.",
    eventName: "FAQ2_clicked",
    eventDesc: "user clicks on FAQ2",
  },
  {
    key: "faq-03",
    index: "03",
    title: "How do I know which plan is right for me?",
    desc: "You don't need to figure that out on your own. Once you tell us what you're working on, one of our doctors or coaches reviews your health details and puts together a highly precise, personalised plan built around your body, not a generic template. The condition you pick just gets the right person looking at your case first.",
    eventName: "FAQ3_clicked",
    eventDesc: "user clicks on FAQ3",
  },
];

// Testimonials data
const ENROLL_PAGE_TESTIMONIALS = [
  {
    quote:
      "For the first time in years, I feel in control of my health. Twin's approach to personalized care and real-time insights has completely transformed the way I live.",
    name: "Sanjay Sharma",
    role: "Twin Member",
  },
  {
    quote:
      "After years of battling PMOS and failed diets, Twin Health was a game-changer. My energy levels are higher, and for the first time, my weight is steadily dropping without extreme diets.",
    name: "Renuka",
    role: "Twin Member",
  },
  {
    quote:
      "When I joined Twin, my A1C was 12.4%. Now it's 6.2%! I’ve also stopped taking insulin entirely. Twin taught me how to make small, meaningful changes that fit my lifestyle.",
    name: "AM Mohammed",
    role: "Twin Member",
  },
  {
    quote:
      "I’ve tried everything for my fatty liver condition, but nothing worked long-term. With Twin’s guidance, my liver health has improved significantly, and I’m feeling lighter and more active every day.",
    name: "Chef Kumar",
    role: "Twin Member",
  },
  {
    quote:
      "Before Twin, my weight-loss efforts always plateaued. Now, I’ve lost 10 kilos, my cholesterol is normal, and I’ve never felt more confident in my health.",
    name: "Firdose Ahmed",
    role: "Twin Member",
  },
  {
    quote:
      "It’s incredible to feel this supported. My care team is always there, guiding me with practical tips that really work. I’m no longer dependent on diabetes medications, and my sugar levels are steady.",
    name: "Aarthi Shetty",
    role: "Twin Member",
  },
  {
    quote:
      "Six months ago, I could barely climb stairs without getting breathless. Thanks to Twin, I’ve regained my stamina and can now manage a 5 km walk every weekend!",
    name: "Shankar Rao",
    role: "Twin Member",
  },
  {
    quote:
      "I struggled with high blood pressure and fatigue for years. Twin's personalized approach showed me exactly how to manage my lifestyle, and now my BP is under control without medications.",
    name: "Komal Kumari",
    role: "Twin Member",
  },
];

// FAQ For FAQ Page
const FAQ_PAGE_FAQ = [
  {
    key: "faq-01",
    index: "01",
    title: "What is Twin Health, and how can it help me?",
    desc: "Twin Health India uses its AI Digital Twin™ to map your unique metabolism and heal its root dysfunction. This precision allows you to safely eliminate medications, regenerate beta cells, and achieve sustainable remission for chronic diseases, moving you from managing to reversing them.",
    eventName: "FAQ1_clicked",
    eventDesc: "user clicks on FAQ1",
  },
  {
    key: "faq-02",
    index: "02",
    title: "What is the Whole Body Digital Twin™?",
    desc: "The AI Digital Twin™ goes beyond tracking health markers to identify the core issue: dysfunctional metabolism. By synthesizing thousands of unique data points, it provides precision lifestyle recommendations, to repair your metabolic engine and reverse chronic disease.",
    eventName: "FAQ2_clicked",
    eventDesc: "user clicks on FAQ2",
  },
  {
    key: "faq-03",
    index: "03",
    title: "Can chronic diseases like Type 2 Diabetes really be reversed?",
    desc: "Yes, Twin Health reverses diabetes, moving beyond management. Audited data (IIT Madras) shows 94% achieve reversal in RCTs. The Whole Body Digital Twin™ addresses root cause for clinical remission: 95% stop all meds, 94% stop insulin, and beta cells regenerate. Results start in 2 weeks",
    eventName: "FAQ3_clicked",
    eventDesc: "user clicks on FAQ3",
  },
  {
    key: "faq-04",
    index: "04",
    title: "How is Twin Health different from other health apps or programs?",
    desc: "Twin Health focuses on healing the root cause, metabolism. Unlike diet-only or medication-heavy approaches, it combines AI, real-time data, and compassionate human support.",
    eventName: "FAQ4_clicked",
    eventDesc: "user clicks on FAQ4",
  },
  {
    key: "faq-05",
    index: "05",
    title:
      "Do I need to visit a clinic to participate in Twin Health’s program?",
    desc: "No clinic visits are required. Your care team connects via video calls and chat, while wearable devices monitor your metabolic health from home.",
    eventName: "FAQ5_clicked",
    eventDesc: "user clicks on FAQ5",
  },
  {
    key: "faq-06",
    index: "06",
    title: "What wearable devices will I need?",
    desc: "We build your AI Digital Twin™ using three mandatory smart sensors that sync automatically to the app: a Continuous Glucose Monitor , a Smart Sensor Watch, and a Body Composition Monitor.",
    eventName: "FAQ6_clicked",
    eventDesc: "user clicks on FAQ6",
  },
  {
    key: "faq-07",
    index: "07",
    title: "How soon can I expect to see results?",
    desc: "Results vary by individual, but many members notice better energy, sleep, glucose stability, and mood within a few weeks. Long-term remission follows as metabolism heals.",
    eventName: "FAQ7_clicked",
    eventDesc: "user clicks on FAQ7",
  },
  {
    key: "faq-08",
    index: "08",
    title: "Is Twin Health covered by insurance?",
    desc: "Insurance coverage depends on your provider and plan. Contact us or your insurer to check reimbursement for Twin Health India services.",
    eventName: "FAQ8_clicked",
    eventDesc: "user clicks on FAQ8",
  },
  {
    key: "faq-09",
    index: "09",
    title: "What role does AI play in the Twin Health program?",
    desc: "AI analyses thousands of data points from your body to predict patterns and provide personalized recommendations in real time, guiding your care team.",
    eventName: "FAQ9_clicked",
    eventDesc: "user clicks on FAQ9",
  },
  {
    key: "faq-10",
    index: "10",
    title: "Why is addressing metabolic health important?",
    desc: "Metabolic health atffects diabetes, BP, obesity, fatty liver, inflammation, and long-term vitality. Healing metabolism improves energy, organ function, mood, and quality of life.",
    eventName: "FAQ10_clicked",
    eventDesc: "user clicks on FAQ10",
  },
  {
    key: "faq-11",
    index: "11",
    title: "How does Twin Health compare to other diabetes reversal programs?",
    desc: "Most programs focus on diet or medication adherence. Twin Health India heals the root cause using real-time data and personalised recommendations for long-lasting remission.",
    eventName: "FAQ11_clicked",
    eventDesc: "user clicks on FAQ11",
  },
  {
    key: "faq-12",
    index: "12",
    title: "Why are sensors needed for the Twin Health program?",
    desc: "Sensors track glucose, sleep, steps, activity, and stress. This real-time data goes into the Digital Twin™ to guide precise, personalised metabolic actions.",
    eventName: "FAQ12_clicked",
    eventDesc: "user clicks on FAQ12",
  },
  {
    key: "faq-13",
    index: "13",
    title: "How does Twin Health become a lifetime health partner?",
    desc: "Twin Health India supports you beyond reversal. Your care team provides ongoing guidance, insights, and recommendations to help maintain long-term metabolic health.",
    eventName: "FAQ13_clicked",
    eventDesc: "user clicks on FAQ13",
  },
  {
    key: "faq-14",
    index: "14",
    title: "Which chronic conditions can Twin Health help with?",
    desc: "Twin Health India helps with Type 2 Diabetes, obesity, hypertension, NAFLD, PMOS, dyslipidemia, and other metabolic disorders by healing the underlying cause- metabolism.",
    eventName: "FAQ14_clicked",
    eventDesc: "user clicks on FAQ14",
  },
  {
    key: "faq-15",
    index: "15",
    title: "Why do technology and healthcare leaders trust Twin Health?",
    desc: "Twin Health’s Digital Twin™ technology is globally recognized, clinically validated, and recommended by top doctors for reversing metabolic diseases safely and effectively.",
    eventName: "FAQ15_clicked",
    eventDesc: "user clicks on FAQ15",
  },
  {
    key: "faq-16",
    index: "16",
    title: "Is my medical and health data safe with Twin Health?",
    desc: "Twin Health India is HIPAA, GDPR, and ISO/IEC 27001 compliant. Your data is encrypted and accessible only to authorized care team members.",
    eventName: "FAQ16_clicked",
    eventDesc: "user clicks on FAQ16",
  },
  {
    key: "faq-17",
    index: "17",
    title: "Who will handle my health journey at Twin Health?",
    desc: "Your care team includes medical doctors, nutritionists, fitness experts, and certified health coaches who support your progress at every step.",
    eventName: "FAQ17_clicked",
    eventDesc: "user clicks on FAQ17",
  },
];

// Testimonials data
const EMPLOYEE_STORIES_TESTIMONIALS = [
  {
    quote:
      "Joining Twin Health was a turning point in my career. As part of the Data Science team, I’ve had the privilege of working on AI models that directly improve patients' health outcomes. Seeing real-time results from our work—like a member reversing their diabetes—is incredibly fulfilling. It’s not just a job; it’s a mission.",
    name: "R. Rajendran",
    role: "Senior Associate - MIS",
  },
  {
    quote:
      "As a Health Coach, my role is to guide members on their journey to better health. I’ve seen patients who were reliant on medications regain their freedom through the program. Twin Health has given me the tools and support to not only grow as a professional but also to touch lives in ways I never thought possible.",
    name: "Priyadharshni K",
    role: "Manager - Health Coach",
  },
  {
    quote:
      "I was drawn to Twin Health because of its revolutionary approach to addressing chronic diseases. As a Product Manager, I’ve worked with teams across the globe to develop tools that empower members to take control of their health. What excites me the most is the blend of technology and care—knowing that what we create impacts lives every single day.",
    name: "Nafeesa Mohideen Abdul Cader",
    role: "Product Manager",
  },
  {
    quote:
      "Working on the field has been an eye-opening experience. Every day, I meet individuals struggling with chronic health conditions who are eager for solutions. Representing Twin Health means offering them hope through technology and care. The satisfaction of seeing their lives improve makes this job so fulfilling.",
    name: "Syed Ibrahim",
    role: "Manager - Business Intelligence",
  },
  {
    quote:
      "At Twin Health, I’ve been able to combine my medical expertise with technology to deliver personalized, data-driven care. The Whole Body Digital Twin™ is a game-changer, allowing me to provide precise recommendations for patients. It’s inspiring to be part of a team that’s not just treating symptoms but addressing the root causes of chronic diseases.",
    name: "Dr. Kulshar Begam Ajmal Khan",
    role: "Medical Officer-Clinical Research",
  },
  {
    quote:
      "Working as a Quality Auditor at Twin Health has been an incredibly fulfilling experience. Here, quality isn’t just a metric—it’s a commitment to excellence in everything we do. I take pride in ensuring our processes meet the highest standards, knowing that every improvement directly impacts the lives of our members. Twin gives me the resources and support to excel in this role.",
    name: "Dhanakishore B",
    role: "Senior Associate - QA",
  },
  {
    quote:
      "In the Finance team at Twin Health, I’ve seen how every number tells a story. Managing budgets and forecasting for a mission-driven company like Twin isn’t just about spreadsheets; it’s about enabling life-changing work. The company’s transparent and collaborative environment makes me feel valued and connected to our larger purpose.",
    name: "Thiyagu Kanagaraj",
    role: "Manager - Accounts Receivable",
  },
  {
    quote:
      "At Twin Health, the HR team is more than just a support function—we’re enablers of growth and culture. From recruiting passionate talent to creating a thriving workplace, my role allows me to make a meaningful impact every day. Twin’s focus on employee well-being and development inspires me to give my best.",
    name: "Siddarth Sharma",
    role: "Assistant Manager - HR",
  },
];

const constants = {
  TWINQP_19750: "M1_QUARTERLY",
  TWINAP_69500: "M1_ANNUAL",
  STATES: STATES,
  GENDERS: GENDER,
  PAYMENT_PLANS: PAYMENT_PLANS,
  BOOK_PACK: BOOK_PACK,
  TWIN_STORE: TWIN_STORE,
  REVIEWS: REVIEWS,
  HOME_PAGE: HOME_PAGE,
  BOOKPACK_LANGUAGES: BOOKPACK_LANGUAGES,
  BOOKPACK_ERROR_MESSAGES: BOOKPACK_ERROR_MESSAGES,
  BOOKPACK_PINCODE_MESSAGES: BOOKPACK_PINCODE_MESSAGES,
  BOOKPACK_CATEGORIES: BOOKPACK_CATEGORIES,
  DOCTOR_REFERRAL: DOCTOR_REFERRAL,
  CSV_UPLOAD_VIDEOS: CSV_UPLOAD_VIDEOS,
  CSV_UPLOAD_DOWNLOAD_LINKS: CSV_UPLOAD_DOWNLOAD_LINKS,
  GET_IN_TOUCH_LANGUAGES,
  GET_IN_TOUCH_TIMES,
  HOME_PAGE_V2: HOME_PAGE_V2,
  METABOLIC_ASSESSMENT_QUESTIONS: METABOLIC_ASSESSMENT_QUESTIONS,
  QUIZ_HEIGHT: QUIZ_HEIGHT,
  METABOLIC_ASSESSMENT_RESULTPAGE_PARA: METABOLIC_ASSESSMENT_RESULTPAGE_PARA,
  QUIZ_LANGUAGES: QUIZ_LANGUAGES,
  DOCTOR_SPECIALISATION: DOCTOR_SPECIALISATION,
  METABOLIC_ASSESSMENT_THANKYOUPAGE_VIDEO:
    METABOLIC_ASSESSMENT_THANKYOUPAGE_VIDEO,
  WBDT_TREATMENT_PLANS: WBDT_TREATMENT_PLANS,
  HEADER_NAV_ITEMS: HEADER_NAV_ITEMS,
  HEADER_CTA_BUTTONS: HEADER_CTA_BUTTONS,
  MIXPANEL_HEADER_CONFIG: MIXPANEL_HEADER_CONFIG,
  FOOTER_NAV_ITEMS: FOOTER_NAV_ITEMS,
  FOOTER_SOCIAL_LINKS: FOOTER_SOCIAL_LINKS,
  FOOTER_APP_LINKS: FOOTER_APP_LINKS,
  FOOTER_CONTACT_INFO: FOOTER_CONTACT_INFO,
  FOOTER_LEGAL_LINKS: FOOTER_LEGAL_LINKS,
  MIXPANEL_FOOTER_CONFIG: MIXPANEL_FOOTER_CONFIG,
  AI_DIGITAL_TWIN_CARDS: AI_DIGITAL_TWIN_CARDS,
  ABOUT_PROGRAM_PAGE_CARDS: ABOUT_PROGRAM_PAGE_CARDS,
  HOW_TWIN_WORK_CARDS: HOW_TWIN_WORK_CARDS,
  CLINICAL_RESEARCH_CARDS: CLINICAL_RESEARCH_CARDS,
  SUCCESS_STORIES_VIDEOS: SUCCESS_STORIES_VIDEOS,
  HOMEPAGE_FAQ: HOMEPAGE_FAQ,
  ABOUT_PROGRAM_FAQ: ABOUT_PROGRAM_FAQ,
  FOR_EMPLOYERS_FAQ: FOR_EMPLOYERS_FAQ,
  FOR_DOCTORS_PAGE_FAQ: FOR_DOCTORS_PAGE_FAQ,
  FOR_INSURERS_PAGE_FAQ: FOR_INSURERS_PAGE_FAQ,
  ENROLL_NOW_PAGE_FAQ: ENROLL_NOW_PAGE_FAQ,
  ENROLL_PAGE_TESTIMONIALS: ENROLL_PAGE_TESTIMONIALS,
  FAQ_PAGE_FAQ: FAQ_PAGE_FAQ,
  EMPLOYEE_STORIES_TESTIMONIALS: EMPLOYEE_STORIES_TESTIMONIALS,
};

export default constants;
